import { render, staticRenderFns } from "./FoodManage.vue?vue&type=template&id=a17ae1c6&"
import script from "./FoodManage.vue?vue&type=script&lang=js&"
export * from "./FoodManage.vue?vue&type=script&lang=js&"
import style0 from "./FoodManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports